import { FlaskConical } from "lucide-react";
import type { SmsStatus, SmsSummary } from "../../../api/types";
import { cn } from "../../../components/ui";
import { fmtDate } from "../../../utils/labels";

export const SMS_STATUS_LABEL: Record<SmsStatus, string> = { VERIFIED: "Verified", UNVERIFIED: "Unverified", OPTED_OUT: "Opted out", CONFLICT: "Conflict" };
const TONE: Record<SmsStatus, string> = {
  VERIFIED: "border-emerald-500/50 bg-emerald-500/10 text-emerald-300",
  UNVERIFIED: "border-zinc-600 bg-zinc-800/40 text-zinc-400",
  OPTED_OUT: "border-warn/50 bg-warn/10 text-warn",
  CONFLICT: "border-signal/60 bg-signal/10 text-red-200",
};

export function SmsStatusPill({ status, testId }: { status: SmsStatus; testId: string }) {
  return <span data-testid={testId} className={cn("inline-flex whitespace-nowrap rounded-sm border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider", TONE[status])}>{SMS_STATUS_LABEL[status]}</span>;
}

export function lastActivity(s?: SmsSummary | null): string {
  if (!s?.last_sms_at) return "No SMS yet";
  return `${fmtDate(s.last_sms_at)} · ${s.last_sms_direction === "INBOUND" ? "received" : "sent"}`;
}

export function PreviewToolBadge({ testId }: { testId: string }) {
  return (
    <span data-testid={testId} className="inline-flex items-center gap-1 rounded-sm border border-sky-400/50 bg-sky-400/10 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-sky-300">
      <FlaskConical className="h-3 w-3" /> Preview tool
    </span>
  );
}

export const EVENT_STATUS_TONE: Record<string, string> = {
  BLOCKED_COMPLIANCE: "text-warn",
  SUPPRESSED_OPT_OUT: "text-warn",
  INVALID_SIGNATURE: "text-signal",
  RATE_LIMITED: "text-warn",
  FAILED: "text-signal",
  SENT: "text-emerald-300",
  REPLIED: "text-emerald-300",
};
